import {
  IConfigurationParams,
  ConfigurationNames,
  CaptchaType,
} from '../../../../graphql/configuration/models/configuration.models';

export const getCaptcha = (configuration: IConfigurationParams[]): {
  isEnabled: boolean; type: CaptchaType | undefined, isVisibleCaptcha: boolean;
} => {
  const captchaParams = configuration.find((
    params,
  ) => params.name === ConfigurationNames.captcha);

  return captchaParams
    ? {
      isEnabled: JSON.parse(captchaParams.configuration).enabled || false,
      type: JSON.parse(captchaParams.configuration).type || undefined,
      isVisibleCaptcha: JSON.parse(captchaParams.configuration).visibleSmartCaptcha,
    }
    : { isEnabled: false, type: undefined, isVisibleCaptcha: false };
};
